import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Container } from "design-react-kit";
import { BoxDanger, ModalHandler, Title } from "components/misc";
import { MTable } from "components/table";

import { MnemoLoading } from "components/misc";
import { adminService, dateHelper, networkErrorHelper } from "libs";

import { Row, Col } from "design-react-kit";

import { MInput } from "components/forms";

class LessonTrainingAccessAnomaly extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rightEmail: "",
      wrongEmail: "",
      selectedAnomalyId: null,
      loading: false,
      payload: [],
      payloadToRender: [],
      rndKey: Math.floor(Math.random() * 1000 + 1),
    };
  }

  tableConfig = {
    columns: [
      {
        id: "id", // identifier of columns
        Header: "id",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "id", // accessor is the "key" in the data
      },
      {
        id: "anomaly_name",
        Header: "Nome",
        accessor: "anomaly_name",
      },
      {
        id: "anomaly_surname",
        Header: "Cognome",
        accessor: "anomaly_surname",
      },
      {
        id: "anomaly_namelabel",
        Header: "NickName",
        accessor: "anomaly_namelabel",
      },
      {
        id: "anomaly_email",
        Header: "Email",
        accessor: "anomaly_email",
      },
      {
        id: "idParent",
        Header: "idLezione",
        accessor: "idParent",
      },
      {
        id: "login",
        Header: "Login",
        accessor: (row) => {
          return row.login ? dateHelper.toITDateTime(row.login) : "";
        },
      },
      {
        id: "logout",
        Header: "Logout",
        accessor: (row) => {
          return row.logout ? dateHelper.toITDateTime(row.logout) : "";
        },
      },
      {
        id: "validNote",
        Header: "Note",
        accessor: "validNote",
      },
    ],
    actions: [
      {
        id: "detail",
        accessor: "id",
        label: "Correggi",
        icon: "it-more-actions",
        className: "MTable-actions",
        onClick: (e, value) => {
          this.setNewData(value);
        },
      },
    ],
  };

  loadAnomalyData = async () => {
    this.setState({ loading: true });

    adminService
      .loadLessonTrainingAccessAnomaly()
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.anomaly).forEach(([key, val]) => {
          items.push(val);
        });
        //--- end: prepare reactTable ---

        this.setState({
          loading: false,
          payload: items,
          payloadToRender: items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            payloadToRender: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
          });
        }
      });
  }; // loadAnomalyData

  confirmNewData = async () => {
    const { rightEmail, wrongEmail, selectedAnomalyId } = this.state;
    const email = (rightEmail || "").trim();

    if (!selectedAnomalyId) {
      alert("Nessuna anomalia selezionata.");
      return;
    }

    if (email === "") {
      alert("Seleziona o inserisci una email valida.");
      return;
    }

    const payload = {
      id: selectedAnomalyId,
      wrongEmail: wrongEmail || "",
      email,
    };

    adminService
      .fixAccessAnomalyWebExTraining(payload)
      .then((data) => {
        this.modalAbort();
        this.loadAnomalyData();
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
      });
  }; // confirmNewData

  modalAbort = () => {
    this.setState({
      rightEmail: "",
      wrongEmail: "",
      selectedAnomalyId: null,
    });
  }; // modalAbort

  setRightEmail = (email) => {
    this.setState({ rightEmail: email });
  }; // setRightEmail

  setNewData = (itemId) => {
    const { payload } = this.state;
    const elementData = payload.find((el) => el.id === itemId);

    const candidates = (elementData.candidates || "")
      .split(";")
      .filter(Boolean)
      .map((row) => row.split(",")); // [name, surname, email] ✅

    // reset selection and store which item we are editing
    this.setState({
      rightEmail: "",
      wrongEmail: elementData.anomaly_email || "",
      selectedAnomalyId: itemId,
    });

    const body = (
      <FixAccessAnomalyBody
        elementData={elementData}
        candidates={candidates}
        initialEmail=""
        onEmailChange={this.setRightEmail}
      />
    );

    ModalHandler.show(
      null,
      "Risolvi Anomalie",
      body,
      this.modalAbort,
      this.confirmNewData,
    );
  }; // setNewData

  //--- ---

  componentDidMount() {
    this.loadAnomalyData();
  }

  //--- ---

  render() {
    const { loading, rndKey, payloadToRender, payload } = this.state;

    return (
      <>
        <section className="my-4">
          {loading ? (
            <MnemoLoading></MnemoLoading>
          ) : (
            <Container>
              <Title>Gestione Anomalie di Accesso</Title>
              <hr />

              <MTable
                key={rndKey}
                tableData={payloadToRender}
                tableConfig={this.tableConfig}
              />

              {payload.length === 0 && (
                <BoxDanger key="nrp-1" className="my-3">
                  Lista utenti.
                  <div className="small text-info">
                    {" "}
                    Non sono presenti dati.
                  </div>
                </BoxDanger>
              )}
            </Container>
          )}
        </section>
      </>
    );
  }
} // LessonTrainingAccessAnomaly

class FixAccessAnomalyBody extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedEmail: props.initialEmail || "",
    };
  }

  toggleEmail = (email) => {
    const next = email === this.state.selectedEmail ? "" : email;

    this.setState({ selectedEmail: next });

    if (this.props.onEmailChange) {
      this.props.onEmailChange(next);
    }
  }; // toggleEmail

  onInputChange = (name, value) => {
    const next = value ?? ""; // NO trim here

    this.setState({ selectedEmail: next });

    if (this.props.onEmailChange) {
      this.props.onEmailChange(next);
    }
  }; // onInputChange

  render() {
    const { elementData, candidates } = this.props;
    const { selectedEmail } = this.state;

    return (
      <>
        <div className="mt-0">
          Correggi le anomalie di accesso alla lezione per l'utente{" "}
          <b>
            {elementData.anomaly_name} {elementData.anomaly_surname} (
            {elementData.anomaly_namelabel})
          </b>{" "}
          per la <b>lezione {elementData.idParent}</b> del{" "}
          <b>{dateHelper.toITDateTime(elementData.dateStart)}</b> email
          utilizzata: <b>{elementData.anomaly_email}</b>
        </div>

        <div className="mt-3">
          <b>Seleziona una proposta valida:</b>
        </div>

        <ul className="mt-2">
          {candidates.map(([name, surname, email], idx) => (
            <li
              key={idx}
              onClick={() => this.toggleEmail(email)}
              style={{ cursor: "pointer" }}
            >
              {/* Bootstrap/design-react-kit: usa text-danger */}
              <div className={selectedEmail === email ? "text-danger" : ""}>
                {name} {surname} {email}
              </div>
            </li>
          ))}
        </ul>

        <hr />

        <div className="mt-3">
          <b>oppure assegna email Account presente su Formazione Docenti :</b>
        </div>

        <Row className="row col-md-12 mt-3">
          <Col>
            <MInput
              name="email"
              field="email"
              label="email valida in piattaforma"
              type="text"
              className="mt-2 mb-1"
              value={selectedEmail}
              onChange={this.onInputChange}
            />
          </Col>
        </Row>
      </>
    );
  }
} // FixAccessAnomalyBody

export default withRouter(LessonTrainingAccessAnomaly);
